import type { StickyFooterProps } from './StickyFooter.typed';

import { Container } from './StickyFooter.styled';

const StickyFooter = (props: StickyFooterProps) => {
  const { children, className } = props;

  return <Container className={className}>{children}</Container>;
};

export { StickyFooter };
